<span
  [ngbPopover]="details > '0' ? customPopover : null"
  triggers="mouseenter:mouseleave"
  placement="right"
  container="body">
  {{ details }}
</span>

<ng-template #customPopover>
 <!-- <div class="popover-header">
    Organizations
  </div> -->
  <ul class="popover-list mb-0">
    <li *ngFor="let org of organizations">{{ org.SalesOrgName }}</li>
  </ul> 
</ng-template>